document.addEventListener("DOMContentLoaded", () => {
    // Locate the estimation form
    const container = document.querySelector("form#estimation-form")
    if (!container) return

    const summaryTable = container.querySelector("fieldset#summary-table")
    const totalTable = container.querySelector("fieldset#total-table")
    const hasManyContainer = container.querySelector("[data-has-many-association=line_items]")

    const originalEstimationField = container.querySelector("[name$='_estimation[original_estimation_id]']")
    const isRevisedEstimation = originalEstimationField && originalEstimationField.value !== ""

    const excessContainer = container.querySelector("#excess-container")
    const isInitialEstimation = container.querySelector("[name$='[estimation_type]']").value === "initial_estimation"
    const isAdditionalEstimation = !isInitialEstimation
    const isLumpsumMethod = container.dataset?.mode === "lumpsum"
    const isAuditEstimation = container.classList.contains("audit_estimation")
    const isTamam = document.documentElement.dataset.appType === "tamam"
    const enforcePartNumberValidation = isAuditEstimation && isTamam && isInitialEstimation

    const severitySelect = container.querySelector("[name$='[vehicle_damage_severity]']")
    const repairDurationInput = container.querySelector("[name$='[repair_duration_in_days]']")

    const REPAIR_DURATION_RANGES = {
        unselected: {min: 1, max: 99},
        light: {min: 1, max: 3},
        medium: {min: 3, max: 5},
        high_costly: {min: 5, max: 15},
        high_technically: {min: 8, max: 20}
    }


    // --- Constants ---
    const CLASS_BG = {
        red: "bg-red-700",
        yellow: "bg-yellow-200",
        green: "bg-green-700",
        blue: "bg-blue-700",
        black: "bg-slate-700",
        transparent: "bg-transparent"
    }

    const ITEM_LABOR = "labor"
    const ITEM_LUMPSUM = "lumpsum"
    const ITEM_AFTER_CHECK = "after_check"

    const CATEGORIES = {
        labor: "labor",
        repair: "labor",
        lumpsum: "lumpsum",
        original_part: "original_parts",
        aftermarket_part: "aftermarket_parts",
        used_part: "used_parts",
        tires: "tires_wheels_batteries",
        battery: "tires_wheels_batteries",
        wheels: "tires_wheels_batteries",
        wheel_caps: "tires_wheels_batteries",
        other: "other_costs"
    }

    const UNIQUE_CATEGORIES = [...new Set(Object.values(CATEGORIES))]

    const PART_CATEGORIES = ["original_parts", "aftermarket_parts", "used_parts", "tires_wheels_batteries"]

    const PART_NUMBER_REGEX = /^[A-Za-z0-9][A-Za-z0-9\-\/ ]{1,}[A-Za-z0-9]$/
    const PART_NUMBER_MESSAGE = document.querySelector('meta[name="localized-missing-parts-number"]')?.getAttribute("content") || "Please enter a valid part number"

    // --- Helper Functions ---
    const setRowMetadata = itemTypeSelect => {
        const row = itemTypeSelect.closest("tr")
        if (!row) return

        row.dataset.rowRole = itemTypeSelect.value
        row.dataset.rowCategory = CATEGORIES[itemTypeSelect.value]
    }

    const filterOptions = (select, filterValue, keep) => {
        Array.from(select.options).forEach(option => {
            if ((option.value === filterValue) !== keep) option.remove()
        })
    }

    const processItemTypeInput = itemTypeSelect => {
        setRowMetadata(itemTypeSelect)

        if (isInitialEstimation) {
            filterOptions(itemTypeSelect, ITEM_LABOR, itemTypeSelect.value === ITEM_LABOR)

        } else {
            filterOptions(itemTypeSelect, ITEM_AFTER_CHECK, itemTypeSelect.value === ITEM_AFTER_CHECK)
        }

        filterOptions(itemTypeSelect, ITEM_LUMPSUM, itemTypeSelect.value === ITEM_LUMPSUM)
    }

    const updateAddRowTemplate = () => {
        const addRowLink = hasManyContainer.querySelector("tfoot .has-many-add-custom")
        if (!addRowLink) return

        const tempTable = document.createElement("table")
        tempTable.innerHTML = addRowLink.dataset.html

        if (isRevisedEstimation) tempTable.querySelector("tr").classList.add(CLASS_BG.green)

        const itemTypeSelect = tempTable.querySelector("select[name*=item_type]")
        setRowMetadata(itemTypeSelect)

        if (isInitialEstimation) {
            filterOptions(itemTypeSelect, ITEM_LABOR, false)
        } else {
            filterOptions(itemTypeSelect, ITEM_AFTER_CHECK, false)
        }

        filterOptions(itemTypeSelect, ITEM_LUMPSUM, false)

        tempTable.querySelector("[data-cell-role=destroy]")?.remove()

        addRowLink.dataset.html = tempTable.innerHTML
    }

    const configureSpecialRows = () => {
        const specialRow = hasManyContainer.querySelector(`tr[data-row-role=${isLumpsumMethod ? "lumpsum" : "labor"}]`)
        if (!specialRow) return

        specialRow.querySelectorAll("[name*=description], [name*=quantity], [name*=part_number]").forEach(el => el.classList.add("hidden"))
        if (isAdditionalEstimation) return

        const actionTypeCell = specialRow.querySelector("[data-cell-role=action_type]")
        const actionTypeSelect = actionTypeCell.querySelector("select")

        if (actionTypeSelect) {
            actionTypeCell.classList.remove("select", "optional")
            actionTypeCell.classList.add("string", "stringish")
            actionTypeCell.innerHTML = `<input type="text" value="${actionTypeSelect.selectedOptions[0].value}" id="${actionTypeSelect.id}" name="${actionTypeSelect.name}" class="transparent-input" readonly disabled>`
        }

        replaceSpecialItemTypeWithInput(specialRow)
    }

    const replaceSpecialItemTypeWithInput = specialRow => {
        const itemTypeCell = specialRow.querySelector("[data-cell-role=item_type]")
        if (!itemTypeCell) return

        const itemTypeSelect = itemTypeCell.querySelector("select")
        if (!itemTypeSelect) return

        const specialRowInput = createElement("input", {
            type: "text",
            id: `localized_${isLumpsumMethod ? "lumpsum" : "labor"}`,
            value: itemTypeSelect.selectedOptions[0].textContent,
            disabled: itemTypeSelect.disabled,
            readOnly: true
        })

        const specialRowLocalizadInput = createElement("input", {
            type: "hidden",
            id: itemTypeSelect.id,
            name: itemTypeSelect.name,
            value: itemTypeSelect.value,
            disabled: itemTypeSelect.disabled,
            readOnly: true
        })

        itemTypeCell.innerHTML = ""
        itemTypeCell.appendChild(specialRowInput)
        itemTypeCell.appendChild(specialRowLocalizadInput)
    }

    const processLineItemChange = event => {
        const row = event.target.closest("tr")
        const unitPrice = parseFloat(row.querySelector("[name*=unit_price]").value) || 0
        const quantity = parseFloat(row.querySelector("[name*=quantity]").value) || 0
        const totalField = row.querySelector("[name*=total]")

        totalField.value = (unitPrice * quantity).toFixed(2)

        setRowMetadata(row.querySelector("[name$='[item_type]']"))
        colorizeRow(row.querySelector("[name$='[action_type]']"))
        updateUnitPriceMinAttribute(row)
        updatePartNumberRequired(row)
        refreshSummaryTable()
    }

    const updateUnitPriceMinAttribute = row => {
        const actionTypeSelect = row.querySelector("[name$='[action_type]']")
        const itemTypeSelect = row.querySelector("[name$='[item_type]']")
        const unitPriceInput = row.querySelector("[name$='[unit_price]']")

        if (actionTypeSelect.value !== "replace" || itemTypeSelect.value === "other" || itemTypeSelect.value === "repair") {
            Object.assign(unitPriceInput, {min: 0})

        } else {
            Object.assign(unitPriceInput, {min: 0.01})
        }
    }

    const updatePartNumberRequired = row => {
        if (!enforcePartNumberValidation) return

        const partNumberInput = row.querySelector("[name*=part_number]")
        if (!partNumberInput) return

        const itemType = row.querySelector('[name$="[item_type]"]')?.value
        const actionType = row.querySelector('[name$="[action_type]"]')?.value
        const isRequired = PART_CATEGORIES.includes(CATEGORIES[itemType]) && actionType === "replace"

        partNumberInput.required = isRequired
        validatePartNumberFormat(partNumberInput)
    }

    const validatePartNumberFormat = input => {
        if (input.required && input.value && !PART_NUMBER_REGEX.test(input.value)) {
            input.setCustomValidity(PART_NUMBER_MESSAGE)
        } else {
            input.setCustomValidity("")
        }
    }

    const setupPartNumberValidation = () => {
        if (!enforcePartNumberValidation) return

        hasManyContainer.addEventListener("input", event => {
            if (event.target.matches("[name*=part_number]")) {
                validatePartNumberFormat(event.target)
            }
        })
    }

    const refreshPartNumberRequirements = () => {
        hasManyContainer.querySelectorAll("tbody tr").forEach(updatePartNumberRequired)
    }

    const refreshSummaryTable = () => {
        UNIQUE_CATEGORIES.forEach(category => {
            const subtotalField = summaryTable.querySelector(`[name*="[${category}_subtotal]"`)
            if (!subtotalField) return

            let total = 0
            hasManyContainer.querySelectorAll(`[data-row-category=${category}] [name*=total]`).forEach(field => {
                const row = field.closest("tr")
                const activeLine = row.querySelector('[name$="[action_type]"]')?.value === "replace"

                if (activeLine)
                    total += parseFloat(field.value) || 0
            })

            subtotalField.value = total.toFixed(2)

            calculateCategoryTotals.apply(subtotalField)
        })
    }

    const calculateCategoryTotals = function () {
        const row = this.closest("tr")
        const subtotal = parseFloat(row.querySelector("[name*=_subtotal]").value) || 0
        const discountPercentage = parseFloat(row.querySelector("[name*=discount_percentage]").value) || 0

        const totalAfterDiscount = subtotal * (1 - discountPercentage / 100)
        row.querySelector("[name*=_total]").value = totalAfterDiscount.toFixed(2)

        const depreciationPercentageField = row.querySelector("[name*=_depreciation_percentage]")
        const depreciationAmountField = row.querySelector("[name*=_depreciation_amount]")

        let depreciationPercentage = parseFloat(depreciationPercentageField?.value) || 0
        let depreciationAmount = parseFloat(depreciationAmountField?.value) || 0

        if (excessContainer !== null) {
            const excessCollector = excessContainer.querySelector("[name*=excess_collector]")

            if (excessCollector !== null && depreciationAmountField !== null) {
                const depreciationType = excessContainer.querySelector("[name*=depreciation_type]")

                if (depreciationType.value === "percentage") {
                    depreciationPercentage = parseFloat(depreciationPercentageField?.value) || 0
                    depreciationAmount = totalAfterDiscount * (depreciationPercentage / 100)
                    depreciationAmountField.value = depreciationAmount.toFixed(2)


                } else if (depreciationType.value === "amount") {
                    depreciationAmount = parseFloat(depreciationAmountField?.value) || 0

                } else {
                    depreciationAmount = 0
                }
            }

            const totalAfterExcess = row.querySelector("[name*=_total_after_excess]")
            if (totalAfterExcess) totalAfterExcess.value = (totalAfterDiscount - depreciationAmount).toFixed(2)
        }

        refreshTotalTable()
    }

    const refreshTotalTable = () => {
        let subtotal = 0

        const vatPercentage = parseFloat(container.querySelector('[name$="[vat_percentage]"]').value) || 0

        summaryTable.querySelectorAll(":not(:has(#do-not-calculate)) [name*='_total]']").forEach(field => {
            subtotal += parseFloat(field.value) || 0
        })

        const vatValue = subtotal * vatPercentage / 100
        const totalValue = subtotal + vatValue
        let totalLessExcessValue = 0

        if (excessContainer !== null) {
            const excessCollector = excessContainer.querySelector("[name*=excess_collector]")
            if (excessCollector.value !== "none") {
                const deductibleVatInclusive = excessContainer.querySelector("[name*=deductible_vat_inclusive]:checked")
                const depreciationVatInclusive = excessContainer.querySelector("[name*=depreciation_vat_inclusive]:checked")

                const deductibleAmount = parseFloat(excessContainer.querySelector("[name*=deductible_amount]").value) || 0
                const originalPartsDepreciationAmount = parseFloat(summaryTable.querySelector("[name*=original_parts_depreciation_amount]").value) || 0
                const tiresWheelsBatteriesDepreciationAmount = parseFloat(summaryTable.querySelector("[name*=tires_wheels_batteries_depreciation_amount]").value) || 0
                const totalDepreciationAmount = originalPartsDepreciationAmount + tiresWheelsBatteriesDepreciationAmount

                totalLessExcessValue += deductibleAmount
                totalLessExcessValue += totalDepreciationAmount

                if (deductibleVatInclusive === null)
                    totalLessExcessValue += (deductibleAmount * vatPercentage / 100)

                if (depreciationVatInclusive === null)
                    totalLessExcessValue += (totalDepreciationAmount * vatPercentage / 100)

            }
        }

        const totalDueAmountValue = Math.max(totalValue - totalLessExcessValue, 0);

        // const workshopEstimationTotal = parseFloat(summaryTable.querySelector("#workshop_estimation_total")?.value)
        //
        // const savingPercentage = summaryTable.querySelector("#saving_percentage b")
        //
        // if (workshopEstimationTotal && savingPercentage) {
        //     const savingPercentageValue = workshopEstimationTotal === 0 ? 0 : 100 - (100 * totalValue / workshopEstimationTotal)
        //
        //     savingPercentage.innerText = `${savingPercentageValue.toFixed(2)}%`
        //
        //     savingPercentage.classList.remove(...Object.values(CLASS_TEXT_COLOR))
        //
        //     if (savingPercentageValue > 0) {
        //         savingPercentage.classList.add(CLASS_TEXT_COLOR.green)
        //
        //     } else if (savingPercentageValue < 0) {
        //         savingPercentage.classList.add(CLASS_TEXT_COLOR.red)
        //     }
        // }

        Object.assign(totalTable.querySelector('[name$="[subtotal]"]'), {value: subtotal.toFixed(2)})
        Object.assign(totalTable.querySelector('[name$="[vat]"]'), {value: vatValue.toFixed(2)})
        Object.assign(totalTable.querySelector('[name$="[total]"]'), {value: totalValue.toFixed(2)})

        if (excessContainer !== null) {
            Object.assign(totalTable.querySelector('[name$="[total_less_excess]"]'), {value: totalLessExcessValue.toFixed(2)})
            Object.assign(totalTable.querySelector('[name$="[total_due_amount]"]'), {value: totalDueAmountValue.toFixed(2)})
        }
    }

    const processActionTypeChange = event => {
        const row = event.target.closest("tr")

        colorizeRow(event.target)
        handleInputsVisibility(event.target)
        updateUnitPriceMinAttribute(row)
        updatePartNumberRequired(row)
        refreshSummaryTable()
    }

    const colorizeRow = actionTypeSelect => {
        const row = actionTypeSelect.closest("tr")
        const itemTypeSelect = row.querySelector('[name$="[item_type]"]')
        const noOriginalEstimationLineItem = row.querySelector('[name$="[original_estimation_line_item_id]"]')?.value === ""
        const isNewLineItem = isRevisedEstimation && noOriginalEstimationLineItem

        row.classList.remove(...Object.values(CLASS_BG))

        if (actionTypeSelect.value === "remove") {
            row.classList.add(CLASS_BG.red)

        } else if (actionTypeSelect.value === "delete") {
            row.classList.add(CLASS_BG.black)

        } else if (itemTypeSelect.value === "after_check") {
            row.classList.add(CLASS_BG.blue)

        } else if (actionTypeSelect.value === "repair") {
            row.classList.add(CLASS_BG.yellow)

        } else if (actionTypeSelect.value === "replace" && isNewLineItem) {
            row.classList.add(CLASS_BG.green)

        } else {
            row.classList.add(CLASS_BG.transparent)
        }
    }

    const handleInputsVisibility = actionTypeSelect => {
        const row = actionTypeSelect.closest("tr")

        if (row.dataset.rowRole === ITEM_LABOR || row.dataset.rowRole === ITEM_LUMPSUM) return

        if (actionTypeSelect.value === "replace") {
            row.querySelector("[name*=total]").classList.remove("hidden")
            row.querySelectorAll("[name*=quantity], [name*=part_number], [name*=unit_price]").forEach(el => {
                el.disabled = false
                el.classList.remove("hidden")
            })

            return true;
        }

        const idField = row.querySelector('[name$="[id]"]')
        const associatedLineItemIdField = row.querySelector('[name$="[associated_line_item_id]"]')

        if (actionTypeSelect.value === "remove" && idField.value === "" && associatedLineItemIdField.value === "") {
            row.remove()

        } else {
            row.querySelectorAll("[name*=quantity], [name*=part_number], [name*=unit_price], [name*=total]").forEach(el => {
                el.disabled = true
                el.classList.add("hidden")
            })
        }
    }

    const removeDestroyCells = () => {
        hasManyContainer.querySelectorAll('[data-cell-role=destroy]').forEach(cell => cell.remove())
    }

    const formatRows = () => {
        const inputs = hasManyContainer.querySelectorAll('[name$="[action_type]"]')
        inputs.forEach(handleInputsVisibility)
        inputs.forEach(colorizeRow)
    }

    const processItemTypeInputs = () => {
        hasManyContainer.querySelectorAll("select[name*=item_type]").forEach(processItemTypeInput)
    }

    const styleSummaryTable = () => {
        summaryTable.querySelectorAll("td li.input input").forEach(input => {
            const li = input.closest("li.input")
            li.after(input)
            li.remove()
        })
    }

    const handleExcessFieldsVisibility = () => {
        if (excessContainer !== null) {
            const excessCollector = excessContainer.querySelector("[name*=excess_collector]")
            const excessFieldsContainer = excessContainer.querySelector("#excess-fields-container")
            const depreciationType = excessContainer.querySelector("[name*=depreciation_type]")

            const excessAmountFields = summaryTable.querySelectorAll(".excess-amount-field")
            const excessPercentageFields = summaryTable.querySelectorAll(".excess-percentage-field")

            excessFieldsContainer.classList.add("hidden")
            excessAmountFields.forEach(field => field.classList.add("hidden"))
            excessPercentageFields.forEach(field => field.classList.add("hidden"))

            if (excessCollector.value !== "none") {
                excessFieldsContainer.classList.remove("hidden")
                excessAmountFields.forEach(field => field.classList.remove("hidden"))

                if (depreciationType.value === 'percentage') {
                    excessPercentageFields.forEach(field => field.classList.remove("hidden"))
                    summaryTable.querySelectorAll("[name*=original_parts_depreciation_amount], [name*=tires_wheels_batteries_depreciation_amount]").forEach(field => field.disabled = true)

                } else {
                    summaryTable.querySelectorAll("[name*=original_parts_depreciation_amount], [name*=tires_wheels_batteries_depreciation_amount]").forEach(field => field.disabled = false)
                    excessAmountFields.forEach(field => field.classList.remove("hidden"))
                }
            }
        }
    }

    const setUpTotals = () => {
        hasManyContainer.querySelectorAll("tbody tr").forEach(row => {
            const unitPrice = parseFloat(row.querySelector("[name*=unit_price]").value) || 0
            const quantity = parseFloat(row.querySelector("[name*=quantity]").value) || 0
            const totalField = row.querySelector("[name*=total]")

            totalField.value = (unitPrice * quantity).toFixed(2)
        })

        refreshSummaryTable()
    }

    const handleExcessChange = () => {
        handleExcessFieldsVisibility()
        refreshSummaryTable()
    }

    const updateRepairDurationRange = () => {
        if (container.classList.contains("repair_estimation") || container.classList.contains("additional_estimation")) {
            const range = REPAIR_DURATION_RANGES[severitySelect.value]
            if (range) {
                repairDurationInput.min = range.min
                repairDurationInput.max = range.max

            } else {
                repairDurationInput.min = REPAIR_DURATION_RANGES["unselected"].min
                repairDurationInput.max = REPAIR_DURATION_RANGES["unselected"].max
            }
        }
    }

    const addEventListeners = () => {
        hasManyContainer.querySelectorAll("[name*=unit_price], [name*=quantity]").forEach(field => {
            field.addEventListener("keyup", processLineItemChange)
        })

        hasManyContainer.querySelectorAll("[name*=item_type]").forEach(select => {
            select.addEventListener("change", processLineItemChange)
        })

        summaryTable.querySelectorAll("[name*=percentage], [name*=amount]").forEach(field => {
            field.addEventListener("keyup", calculateCategoryTotals)
        })

        hasManyContainer.querySelectorAll("[name*=action_type]").forEach(select => {
            select.addEventListener("change", processActionTypeChange)
        })

        if (excessContainer !== null) {
            excessContainer.querySelectorAll("[name*=excess_collector], [name*=depreciation_type], [name*=deductible_amount], [name*=deductible_vat_inclusive], [name*=depreciation_vat_inclusive]").forEach(select => {
                select.addEventListener("change", handleExcessChange)
            })
        }

        severitySelect.addEventListener("change", updateRepairDurationRange)
    }

    const addFormEventListener = () => {
        hasManyContainer.closest("form").addEventListener("submit", (e) => {
            hasManyContainer.querySelector("#localized_labor, #localized_lumpsum")?.remove()

            hasManyContainer.querySelectorAll('[name$="[action_type]"]').forEach(actionTypeSelect => {
                if (actionTypeSelect.value === "remove") {
                    const row = actionTypeSelect.closest("tr")

                    row.querySelectorAll('input').forEach(input => {
                        input.required = false
                    })

                    const idField = row.querySelector('[name$="[id]"]')
                    const associatedLineItemIdField = row.querySelector('[name$="[associated_line_item_id]"]')

                    if (idField.value === "" && associatedLineItemIdField.value === "") {
                        row.remove()

                    } else if (row.querySelector("[name*=associated_line_item_id]").value === "") {
                        const destroyInput = createElement("input", {
                            type: "hidden",
                            name: actionTypeSelect.name.replace("action_type", "_destroy"),
                            value: "1"
                        })

                        row.appendChild(destroyInput)
                    }
                }
            })

            hasManyContainer.querySelectorAll("select[name*=action_type]").forEach(actionTypeSelect => {
                if (actionTypeSelect.value === "replace")
                    return

                const row = actionTypeSelect.closest("tr")

                row.querySelectorAll("[name*=description], [name*=quantity], [name*=unit_price]").forEach(el => {
                    el.disabled = false
                })
            })
        })
    }

    // --- Mutation Observer for Dynamic Changes ---
    const observer = new MutationObserver(() => {
        addEventListeners()
        refreshPartNumberRequirements()
    })

    observer.observe(hasManyContainer, {childList: true, subtree: true})

    // --- Main Initialization ---
    processItemTypeInputs()
    configureSpecialRows()
    updateAddRowTemplate()
    removeDestroyCells()
    formatRows()
    refreshPartNumberRequirements()
    setUpTotals()
    styleSummaryTable()
    handleExcessFieldsVisibility()
    updateRepairDurationRange()
    addEventListeners()
    setupPartNumberValidation()
    addFormEventListener()
})
